import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import eatsStreet from "../../../../src/assets/blade-runner/session00/eats-street.webp";
import djDispatch from "../../../../src/assets/blade-runner/session00/dj-dispatch.webp";
import sentinel from "../../../../src/assets/blade-runner/session00/handout-sentinel-2037-01-03.webp";
import leah from "../../../../src/assets/blade-runner/session00/leah.webp";
import marion from "../../../../src/assets/blade-runner/session00/marion-carey-token.webp";
import skinner from "../../../../src/assets/blade-runner/session00/skinner-token.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession00 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Call to Action",
      anchor: "pageTop",
      sectionTitleCssName: "sectionTitleBR",
      text: (
        <div class="bladeRunnerBodyText">
          <ImageComponent
            image={djDispatch}
            caption="DJ Dispatch"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="DJ Dispatch is a former model, singer, and actress. Stories of how or why she become the voice of LAPD dispatch are many, and none can be proved."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The neon hum of Los Angeles never sleeps, and neither does DJ
          Dispatch. Her voice purrs across the LAPD's Rep-Detect unit monitors:
          <br />
          <br />
          <b>DJ Dispatch: </b>
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Attention all units, this is not a drill. Human supremacist rally
            gone bad near the University of Los Angeles. Riot conditions. Full
            riot gear, full caution. Perimeter lockdown—Sector Two is burning."
          </font>
          <br />
          <br />
          In the RDU situation room, Sergeant Reardon kills the feed and locks
          eyes on rookie Replicant Marion Carey. <br />
          <br />
          <b>Sgt Reardon: </b>
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Holden wants you in the air now. You've got a veteran to
            collect—Skinner's probably still at the Dragon Noodle Bar. And
            Marion, Leah and Sandor are on scene. One's down. The other's in
            deep trouble.”
          </font>
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "The Pick Up",
      text: (
        <div class="bladeRunnerFont">
          <ImageComponent
            image={sentinel}
            caption="Sentinel"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The Independent Sentinel for Jan 01, 2037."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Cut to the steam-slick streets of Little Tokyo. Inside the White
          Dragon Noodle Bar, Skinner—long hair, beard, and a wardrobe assembled
          entirely by accident—is mid-verbal duel with Chuck, the bar's wiley
          asiatic chef who bounces between cityspeak, cowboy-slang, and mock
          obsequiousness. Skinner's reading the newspaper; the headline reads:
          <br />
          <br />
          <b>Independent Sentinel: </b>
          <font style={{ fontStyle: "italic", color: "lightgreen" }}>
            “Nexus-9 Launch a Resounding Success”.
          </font>
          <br />
          <br />
          Enter Marion, built like a sculpted monument, a callback to famous
          football players of the 20th century. He glows with the quiet
          confidence of someone who hasn't yet learned how deep the city's rot
          runs. After all, he is a nexus-9 model number MC7-4-.42, less than a
          year old. <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Hey Big boy,”
          </font>{" "}
          Skinner greets him, finishing his noodles before answering Holden's
          call and following Marion into a spinner.
          <br />
          <br />
        </div>
      ),
    },
    {
      title: "Into the Fire",
      text: (
        <div class="bladeRunnerFont">
          <i>Eats Street Riot at animoid cafe ChikuChicku</i>
          <img
            style={{ maxHeight: "400px", display: "block", margin: "0 auto" }}
            src={eatsStreet}
            alt="Eats Street Riot at ChikuChick animoid Cafe"
          />
          <br />
          The spinner punches through falling snow toward Sector 2. Below, the
          riot spills through streets glowing with “Happy New Year 2037”
          holoboards. Looters run with stolen goods, gunshots crack in the rain,
          and a man dressed as Santa hides in an alley. This is Los Angeles at
          its worst—and at its most honest.
          <br />
          <br />
          The coordinates drop them on Eats Street, outside the animoid café
          ChikuChiku. Leah bursts from cover, dodging PK-D fire.
          <br />
          <br />
          <b>Leah</b>:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Two supremacists—Alonzo and Ghost—trashed the café, slaughtered the
            animoid hedgehogs, and rigged the automaton chef with an IED. Sandor
            went in… now they've got him. And his blaster...”
          </font>
        </div>
      ),
    },
    {
      title: "Negotiations & Gunfire",
      text: (
        <div class="bladeRunnerFont">
          <ImageComponent
            image={leah}
            caption="Leah"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Leah (LH3-7.93): Nexus-9 Blade Runner partnered with Sandor."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner knows the name Alonzo—a lieutenant to Rebel D—and tries
          working the angle, promising exposure in KILL magazine. Marion pulls
          up building schematics on the KIA.
          <br />
          <br /> The trio move like wolves closing a trap. Shots ring out. Leah
          drops Ghost with a heart-shot. Skinner's blaster finds Alonzo's
          pelvis—then, after Alonzo refuses to surrender, finishes the job for
          good.
          <br />
          <br />
        </div>
      ),
    },
    {
      title: "Curtain Falls",
      text: (
        <div class="bladeRunnerFont">
          <ImageComponent
            image={marion}
            caption="Marion"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion Carey, replicant enforcer blade runner, 1 year on the force."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={skinner}
            caption="Skinner"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Skinner, human cityspeaker blade runner, 7 years on the force."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The street smells of cordite and wet concrete. Sandor is rushed to
          hospital. His fate remains uncertain, but two supremacists won't be
          tormenting anyone again. Marion's rookie badge gleams in the spinner's
          cabin light; Skinner's mood ring stays black. The city
          exhales—briefly—before the next storm.
          <br />
          <br />
          <b>
            Skinner <small>(lighting cigarette in the dirty snowfall)</small>:{" "}
          </b>
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "In Los Angeles, justice is just another kind of weather… and it's
            always raining."
          </font>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">TRAINING DAY</h1>
              <small>Blade Runner Session 00</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Holiday riots, human supremacists, and street carnage. Merry
                  Christmas City of Angels, welcome to 2037.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams campaign.{" "}
                </font>
                <br />
                <small>
                  Session 01: <a href="./blade-runner-session-01">Waking Up</a>{" "}
                  ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession00;
